import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { getCartList } from '@/api/cart'
import { getUnreadCount } from '@/api/message'
import { getWxUserInfo } from '@/api/user'
import { getToken, removeToken } from '@/utils/auth'

export default new Vuex.Store({
    state: {
        cartCount: 0,
        unreadMessageCount: 0,
        isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
        username: localStorage.getItem('username') || '',
        token: getToken(),
        userInfo: {}
    },
    mutations: {
        SET_CART_COUNT(state, count) {
            state.cartCount = count
        },
        SET_USER_INFO(state, userInfo) {
            state.isLoggedIn = true
            state.username = userInfo.username
            state.token = userInfo.token
            localStorage.setItem('isLoggedIn', 'true')
            localStorage.setItem('username', userInfo.username)
        },
        SET_USER_DATA(state, userInfo) {
            state.userInfo = userInfo
        },
        SET_UNREAD_COUNT(state, count) {
            state.unreadMessageCount = count
        },
        LOGOUT(state) {
            state.isLoggedIn = false
            state.username = ''
            state.token = null
            state.cartCount = 0
            state.unreadMessageCount = 0
            state.userInfo = {}
            localStorage.removeItem('isLoggedIn')
            localStorage.removeItem('username')
            removeToken()
        }
    },
    actions: {
        async fetchCartCount({ commit }) {
            if (!getToken()) {
                commit('SET_CART_COUNT', 0)
                return
            }
            try {
                const res = await getCartList()
                if (res.code === 200 && res.rows) {
                    const count = res.rows.reduce((sum, item) => sum + (item.quantity || 1), 0)
                    commit('SET_CART_COUNT', count)
                }
            } catch (error) {
                console.error('获取购物车数量失败:', error)
            }
        },
        async fetchUnreadCount({ commit }) {
            if (!getToken()) {
                commit('SET_UNREAD_COUNT', 0)
                return
            }
            try {
                const res = await getUnreadCount()
                if (res.code === 200) {
                    commit('SET_UNREAD_COUNT', res.data || 0)
                }
            } catch (error) {
                console.error('获取未读消息数量失败:', error)
            }
        },
        async fetchUserInfo({ commit }) {
            if (!getToken()) return
            try {
                const res = await getWxUserInfo()
                if (res.code === 200) {
                    commit('SET_USER_DATA', res.data)
                }
            } catch (error) {
                console.error('获取用户信息失败', error)
            }
        }
    },
    modules: {
    }
})
